module.exports = __webpack_public_path__ + "static/media/instagramIcon.2de1cc85.svg";